import * as React from 'react';

const SvgFormDashSquare = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M21 3H3v18h18V3Zm-4 10H7v-2h10v2Z" })
);

export { SvgFormDashSquare as default };
//# sourceMappingURL=FormDashSquare.es.js.map
